import { render } from "./wheelNavigationTiny.vue?vue&type=template&id=d4d27154"
import script from "./wheelNavigationTiny.vue?vue&type=script&lang=js"
export * from "./wheelNavigationTiny.vue?vue&type=script&lang=js"

import "./wheelNavigationTiny.vue?vue&type=style&index=0&id=d4d27154&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__